import React, { useContext, useState, useEffect, useRef } from 'react';
import Papa from 'papaparse';
import '../ProductList.css';
import { useNavigate } from 'react-router-dom';
import Slider from './Silder';
import { Link } from "react-router-dom";
import { images } from './ax2';
import { GoMoveToTop } from "react-icons/go";
import { CartContext } from "../CartContext";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import { productDb } from '../firebaseProducts';
const KidsAccessorie = () => {
  // const { setEmail } = useContext(CartContext);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cart, setCart] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [color, setColor] = useState('');
  const [img, setImg] = useState('');
  // const inputRef = React.useRef(null);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [aspectRatio, setAspectRatio] = useState(75); // default 4:3
  const [selectedTags, setSelectedTags] = useState({
    // Infant: false,
    // Toddler: false,
    // Youth: false,
    // "Sweatshirts": false,
    // 'Full Zip': false,
    // Pants: false,
    // Shorts: false,
    // 'T-Shirts': false,
    // Caps: false,
    // Activewear: false,
    // Outerwear: false,
    // 'Long Sleeve': false,
    // 'Polos/Knits': false
  });
  const [filterMode, setFilterMode] = useState("AND"); // "AND" or "OR"
  const [sliderValue, setSliderValue] = useState(5.8);
  const itemsPerPage = 12;
  const navigate = useNavigate();

  const videoRef = useRef(null);

useEffect(() => {
  if (images.length > 0) {
    const img = new Image();
    img.src = images[0].src;
    img.onload = () => {
      setAspectRatio((img.height / img.width) * 100);
    };
  }
}, [images]);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  }, []);

  // Load CSV Data
  // const loadCSV = async () => {
  //   const csvUrl = '../kidsListAccessoriesMenu.csv'; // Adjust the path

  //   try {
  //     const response = await fetch(csvUrl);
  //     if (!response.ok) throw new Error('Failed to load CSV file');
  //     const csvData = await response.text();

  //     Papa.parse(csvData, {
  //       complete: (result) => {
  //         const data = result.data;
  //         const parsedProducts = data.slice(1).map((item) => ({
  //           Handle: item[29],
  //           ColorVal: item[33],
  //           Size: item[14],
  //           DefaultImageSrc: item[2],
  //           HoverImageSrc: item[23],
  //           Price: parseFloat(item[1]),
  //           Description: item[3],
  //           Style: item[13],
  //           Tags: item[6]?.split(',').map(tag => tag.trim()) || [], // Ensure tags are split and cleaned up
  //         }));

  //         setProducts(parsedProducts);
  //         setFilteredProducts(parsedProducts);
  //         setLoading(false);
  //       },
  //       header: false,
  //       skipEmptyLines: true,
  //     });
  //   } catch (err) {
  //     setError(err.message);
  //     setLoading(false);
  //   }
  // };
  

  // useEffect(() => {
  //   loadCSV();
  // }, []);
const loadFirestoreData = async () => {
  try {
    // console.log("🚀 Fetching products from Firestore…");

    const querySnapshot = await getDocs(collection(productDb, "kids-accessories-menu"));
    // console.log("📦 QuerySnapshot size:", querySnapshot.size);

    const today = new Date();

    const parsedProducts = querySnapshot.docs.map((doc, index) => {
      const data = doc.data();

      // Parse SALE_END_DATE like CSV logic
      // const parseDate = (dateStr) => {
      //   if (!dateStr) return null;
      //   if (typeof dateStr === "string") {
      //     const [month, day, year] = dateStr.split("/").map(Number);
      //     return new Date(year, month - 1, day);
      //   }
      //   return new Date(dateStr); // if already Date or Timestamp
      // };
      const parseDate = (dateStr) => {
  if (!dateStr) return null;

  if (dateStr instanceof Date) {
    return dateStr;
  }

  // Firestore Timestamp
  if (dateStr.toDate) {
    return dateStr.toDate();
  }

  if (typeof dateStr === "string") {
    // Case 1: ISO format "YYYY-MM-DD"
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      const [year, month, day] = dateStr.split("-").map(Number);
      return new Date(year, month - 1, day);
    }

    // Case 2: US format "MM/DD/YYYY"
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateStr)) {
      const [month, day, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day);
    }
  }

  return new Date(dateStr); // fallback
};

      const endSaleDate = parseDate(data.endSale);
// console.log(endSaleDate)
      const isOnSale = endSaleDate && endSaleDate >= today;
      const price = Math.round((parseFloat(data.Price) + 3) * 100) / 100;
const salePrice = Math.round((parseFloat(data.salePrice) + 3) * 100) / 100;
      let discountPercentage = 0;
      if (price > 0 && salePrice > 0 && salePrice < price) {
        discountPercentage = Math.round(((price - salePrice) / price) * 100);
      }
const getFirstValid = (...values) => {
  return values.find(v => v && v.toString().trim() !== "");
};
      return {
        Handle: data.Title2,
        ColorVal: data.Color,
        Size: data.Size,
        DefaultImageSrc: data.img,
        HoverImageSrc:  getFirstValid(data.front, data.SIDE_MODEL),
        Price: price,
        Description: data.Body,
        Style: data.Style,
        SalePrice: salePrice,
        DiscountPercentage: discountPercentage,
        EndSale: endSaleDate,
               Tags : data.Tags
  ? Array.isArray(data.Tags)
    ? data.Tags
    : data.Tags.split(",").map(t => t.trim())
  : [],
        isOnSale,
        Id: doc.id,
      };
    });

    setProducts(parsedProducts);
    // setFilteredProducts(parsedProducts);
    setLoading(false);
  } catch (err) {
    console.error("❌ Error fetching Firestore data:", err);
    setError(err.message);
    setLoading(false);
  }
};

useEffect(() => {
  loadFirestoreData();
}, []);
  // const subs = () => {
  //   const emailValue = inputRef.current.value;
  //   if (emailValue) {
  //     setEmail(emailValue);  // Set email value in the context
  //     inputRef.current.value = "";  // Clear the input field after setting
  //   }
  // }

  // Add to cart functionality
  const handleAddToCart = (product) => {
    navigate(`/kid-product/${product.Style}`);
  };

  // Apply filters, search, and sorting
  useEffect(() => {
    let updatedProducts = [...products];


    // Filter by color
    if (color) {
      updatedProducts = updatedProducts.filter(product =>
        product.ColorVal.split(',').some(c => c.trim().toLowerCase().includes(color.toLowerCase()))
      );
    }
    // Filter by tags
    const selectedTagKeys = Object.keys(selectedTags).filter(tag => selectedTags[tag]);
    if (selectedTagKeys.length > 0) {
      updatedProducts = updatedProducts.filter((product) =>
        filterMode === "AND"
          ? selectedTagKeys.every((tag) => product.Tags.includes(tag))
          : selectedTagKeys.some((tag) => product.Tags.includes(tag))
      );
    }

    // Filter by search term
if (searchTerm) {
  updatedProducts = updatedProducts.filter(product => {
    const handle = product?.Handle?.toLowerCase() || "";
    const desc = product?.Description?.toLowerCase() || "";
    return (
      handle.includes(searchTerm.toLowerCase()) ||
      desc.includes(searchTerm.toLowerCase())
    );
  });
}

    // Sort by price
    const maxPrice = Math.max(...products.map(p => p.Price));
    const minPrice = Math.min(...products.map(p => p.Price));
    const targetPrice = minPrice + ((maxPrice - minPrice) * sliderValue) / 100;
    updatedProducts.sort((a, b) => {
      const diffA = Math.abs(a.Price - targetPrice);
      const diffB = Math.abs(b.Price - targetPrice);
      return diffA - diffB || a.Price - b.Price;
    });

    setFilteredProducts(updatedProducts);
  }, [products, selectedTags, searchTerm, sliderValue, color, filterMode]);

  // Pagination logic
  const indexOfLastProduct = currentPage * itemsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when search term changes
  };

  const handleTagChange = (e) => {
    setSelectedTags((prevTags) => ({
      ...prevTags,
      [e.target.name]: e.target.checked,
    }));
    setCurrentPage(1); // Reset to first page when tag filter changes
  };

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  if (loading) return <span className="loader"></span>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  // return (
  //   <>
  //     <div className="product-list-container" id="product-container">

  //       {/* Sidebar with Filters */}
  //       <div className="sidebar">
  //         <div className="sidebar-content">
  //           {/* <div style={{ textAlign: "center" }}>
  //             <a style={{ color: "white", textDecoration: "none", }} href="/about-us">
  //               <p style={{ fontSize: 15, margin: "auto", marginBottom: 10 }}>
  //                 ABOUT US
  //               </p>
  //             </a>
  //           </div> */}
  //           <div className="slider-container" style={{ marginLeft: -5, alignItems: 'center', width: "100%", }}>
  //             <Slider width={"100%"}
  //               height={130} />

  //           </div>

  //           {/* Search Box */}
  //           <div className="search-box">
  //             <h6 style={{ marginTop: -15, marginLeft: 5, }}>Categories</h6>
  //             <input
  //               type="text"
  //               value={searchTerm}
  //               onChange={handleSearchChange}
  //               placeholder="Search by name or description..."
  //             />
  //           </div>

  //           {/* Tag Filters */}
  //           <div className="checkbox-filters">
  //             {Object.keys(selectedTags).map(tag => (
  //               <label key={tag}>
  //                 <input
  //                   type="checkbox"
  //                   name={tag}
  //                   checked={selectedTags[tag]}
  //                   onChange={handleTagChange}
  //                 />
  //                 {tag}
  //               </label>
  //             ))}
  //           </div>
  //         </div>
  //         <hr style={{ marginTop: -20, marginBottom: 0 }} />
  //         <div className="slider-container" style={{ textAlign: "center", }}>
  //           <label htmlFor="price-slider">Sort by Price</label>
  //           <input
  //             type="range"
  //             id="price-slider"
  //             min="0"
  //             max="100"
  //             value={sliderValue}
  //             onChange={(e) => setSliderValue(parseInt(e.target.value, 10))}
  //           />
  //           <div className="labels" style={{ marginBottom: -15 }}>
  //             <span className="low">$3</span>
  //             <span className="high">$20</span>
  //           </div>
  //         </div>
  //         <hr style={{ marginTop: -10, marginBottom: 0 }} />
  //         {/* <div className="email" style={{
  //           display: "flex",
  //           justifyContent: "center",
  //           alignItems: "center",
  //           flexDirection: "column",
  //           width: "100%",
  //           boxSizing: "border-box"
  //         }}>
  //           <input
  //             ref={inputRef}
  //             style={{
  //               fontSize: "9px",
  //               width: "100%",
  //               maxWidth: "300px",
  //               height: "28px",
  //               padding: "2px",
  //               marginBottom: "-5px",
  //               borderRadius: "15px",
  //               border: "2px, solid, white"
  //             }}
  //             type="email"
  //             placeholder='Get notified on our sales'
  //           />

  //           <button onClick={subs} style={{ backgroundColor: "black", color: "white", borderRadius: 15, fontWeight: "bold", marginBottom: 10, height: 30, width: "100%", maxWidth: 200, marginTop: 10 }}>SUBSCRIBE</button>

  //         </div> */}
  //         {/* <div style={{ textAlign: "center", maxWidth:190}}>
  //           <label style={{marginBottom:10}}>Search by Color</label>
  //           <input placeholder="Saerch by color" style={{border:"none",fontSize:14, height:40, textAlign:"center",width:"100%", borderRadius:5}} type="text" OnChange={(e) => setColor(e.target.value)}></input>
  //         </div> */}
  //       </div>

  //       {/* Main Content (Product Grid) */}
  //       <div className="product-grid">
  //         {currentProducts.length > 0 ? (
  //           currentProducts.map((product, index) => (

  //             <div key={index} className="product-card" onClick={() => handleAddToCart(product)}>
  //               <div className="image-container">
  //                 {product.isOnSale && (
  //                   <div className="sale-badge">{product.DiscountPercentage}% OFF</div>
  //                 )}
  //                 <a href={`/kid-product/${product.Style}`} style={{ textDecoration: "none", color: "black" }}>
  //                   <img
  //                     src={product.DefaultImageSrc}
  //                     alt={product.Handle}
  //                     className="product-image default-image"
  //                   />
                    
  //                   <img
  //                     src={product.HoverImageSrc}
  //                     alt={`${product.Handle} Hover`}
  //                     className="product-image hover-image"
  //                   />
  //                 </a>
  //               </div>
  //               <div className="product-details">
  //                 <h3 className="product-handle">{product.Handle}</h3>
  //                 {/* <p className="product-price">Price: From ${product.Price}</p> */}
  //                 <div className="product-price">
  //                   Price: From{" "}
  //                   {product.SalePrice > 0 && product.SalePrice < product.Price ? (
  //                     <>
  //                       <p className="product-price" style={{ textDecoration: 'line-through', color: 'grey' }}>${product.Price}</p>{" "}
  //                       <p className="text-red-600 font-bold">${product.SalePrice}</p>
  //                     </>
  //                   ) : (
  //                     <> ${product.Price}</>
  //                   )}
  //                 </div>
  //               </div>
  //               <div className="product-details2">
  //                 {product.Size}
  //               </div>
  //             </div>

  //           ))
  //         ) : (
  //           <p>No products available.</p>
  //         )}
  //       </div>
  //     </div>

  //     <div className="pagination">
  //       <button
  //         style={{ backgroundColor: "white" }}
  //         onClick={() => handlePageChange(1)}
  //         disabled={currentPage === 1}
  //       >
  //         <img
  //           src="/images/assets/arrowFirs.png"
  //           style={{ maxWidth: 35, marginRight: -50}}
  //           alt="First"
  //         />
  //       </button>

  //       <button
  //         style={{ backgroundColor: "white" }}
  //         onClick={() => handlePageChange(currentPage - 1)}
  //         disabled={currentPage === 1}
  //       >
  //         <img src="/left-arrow.png" style={{ maxWidth: 35 }} alt="Prev" />
  //       </button>

  //       <span style={{marginLeft:-10}}>
  //         Page {currentPage} of {totalPages}
  //       </span>

  //       <button
  //         style={{ backgroundColor: "white" }}
  //         onClick={() => handlePageChange(currentPage + 1)}
  //         disabled={currentPage === totalPages}
  //       >
  //         <img src="/right-arrow.png" style={{ maxWidth: 35 , marginLeft:-15}} alt="Next" />
  //       </button>

  //       <button
  //         style={{ backgroundColor: "white" }}
  //         onClick={() => handlePageChange(totalPages)}
  //         disabled={currentPage === totalPages}
  //       >
  //         <img
  //           src="/images/assets/arrowLast.png"
  //           style={{ maxWidth: 35, marginLeft: -50 }}
  //           alt="Last"
  //         />
  //       </button>
  //     </div>
  //                 <div>
  //                   <a
  //                     href="#product-container"
  //                     style={{ textDecoration: "none", color: "black" }}
  //                   >
  //                     <p style={{ fontSize: "30px", fontWeight: "bold" }}>
  //                       <GoMoveToTop />
  //                     </p>
  //                     <p style={{ marginTop: -25 }}>Top</p>
  //                   </a>
  //                 </div>
  //   </>
  // );
  return (
  <>
  <div id="top"></div>
    <div className="product-list-container" id="product-container">
      {/* Sidebar with Filters */}
      <div className="sidebar">
        <div className="sidebar-content">
          <div
            className="slider-container"
            style={{               maxWidth: 250,
              width: "100%",
              position: "relative",
              paddingTop: `${aspectRatio}%`, }}
          >
                    <div
                      style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
                    >
                      <Slider width="100%" height="100%" />
                    </div>
          </div>

          {/* Search Box */}
          <div className="search-box">
            <h6 style={{ marginTop: -10, marginLeft: 5 }}>Categories</h6>
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search by name or description..."
            />
          </div>

          {/* Tag Filters */}
          <div className="checkbox-filters">
              {Object.keys(selectedTags).map((tag) => (
                <label key={tag}>
                  <input
                    type="checkbox"
                    name={tag}
                    checked={selectedTags[tag]}
                    onChange={handleTagChange}
                  />
                  {tag}
                </label>
              ))}
              {/* <hr style={{ marginTop: 10, marginBottom: 5 }} />
              <div className="filter-mode-toggle">
                <label>
                  <input
                    type="radio"
                    name="filterMode"
                    value="AND"
                    checked={filterMode === "AND"}
                    onChange={(e) => setFilterMode(e.target.value)}
                  />
                  Match all
                </label>
                <label>
                  <input
                    type="radio"
                    name="filterMode"
                    value="OR"
                    checked={filterMode === "OR"}
                    onChange={(e) => setFilterMode(e.target.value)}
                  />
                  Match any
                </label>
              </div> */}
            </div>
        </div>

        {/* <hr style={{ marginTop: -20, marginBottom: 0 }} /> */}

        <div className="slider-container" style={{ textAlign: "center" }}>
          <label htmlFor="price-slider">Sort by Price</label>
          <input
            type="range"
            id="price-slider"
            min="0"
            max="100"
            value={sliderValue}
            onChange={(e) => setSliderValue(parseInt(e.target.value, 10))}
          />
          <div className="labels" style={{ marginBottom: -15 }}>
            <span className="low">$3</span>
            <span className="high">$20</span>
          </div>
        </div>

        {/* <hr style={{ marginTop: -10, marginBottom: 0 }} /> */}
      </div>

      {/* Main Content (Product Grid) */}
      <div className="product-grid">
        {currentProducts.length > 0 ? (
          currentProducts.map((product, index) => (
            <div key={index} className="product-card">
              <Link
                to={`/kid-product/${product.Style}`}
                style={{ textDecoration: "none", color: "black" }}
              >
                <div className="image-container">
                  {product.isOnSale && (
                    <div className="sale-badge">
                      {product.DiscountPercentage}% OFF
                    </div>
                  )}
                  <img
                    src={product.DefaultImageSrc}
                    alt={product.Handle}
                    className="product-image default-image"
                  />
                  <img
                    src={product.HoverImageSrc}
                    alt={`${product.Handle} Hover`}
                    className="product-image hover-image"
                  />
                </div>

                <div className="product-details">
                  <h3 className="product-handle">{product.Handle}</h3>
                  <div className="product-price">
                    Price: From{" "}
                    {product.SalePrice > 0 && product.SalePrice < product.Price ? (
                      <>
                        <span
                          className="product-price"
                          style={{
                            textDecoration: "line-through",
                            color: "grey",
                          }}
                        >
                          ${(product.Price).toFixed(2)}
                        </span>{" "}
                        <span className="text-red-600 font-bold">
                          ${(product.SalePrice).toFixed(2)}
                        </span>
                      </>
                    ) : (
                      <> ${(product.Price).toFixed(2)}</>
                    )}
                  </div>
                </div>

               
              </Link>
               <div className="product-details2">{product.Size}</div>
            </div>
          ))
        ) : (
            <img
            style={{ width: 200, marginTop: 10 }}
            src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925292/my_uploads/wyd702qpywbgad4p7xqk.jpg"
            alt="No products found"
          />
        )}
      </div>
    </div>

    {/* Pagination */}
    <div className="pagination">
      <button
        style={{ backgroundColor: "white" }}
        onClick={() => handlePageChange(1)}
        disabled={currentPage === 1}
      >
        <img
          src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925250/my_uploads/o7m7damek0k2zanyyhcb.png"
          style={{ maxWidth: 35, marginRight: -50 }}
          alt="First"
        />
      </button>

      <button
        style={{ backgroundColor: "white" }}
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <img src="/left-arrow.png" style={{ maxWidth: 35 }} alt="Prev" />
      </button>

      <span style={{ marginLeft: -10 }}>
        Page {currentPage} of {totalPages}
      </span>

      <button
        style={{ backgroundColor: "white" }}
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <img
          src="/right-arrow.png"
          style={{ maxWidth: 35, marginLeft: -15 }}
          alt="Next"
        />
      </button>

      <button
        style={{ backgroundColor: "white" }}
        onClick={() => handlePageChange(totalPages)}
        disabled={currentPage === totalPages}
      >
        <img
          src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925251/my_uploads/ocislq4muj6wqc5aks2k.png"
          style={{ maxWidth: 35, marginLeft: -50 }}
          alt="Last"
        />
      </button>
    </div>

    {/* Back to Top */}
    <div>
      <a
        href="#top"
        style={{ textDecoration: "none", color: "black" }}
      >
        <p style={{ fontSize: "30px", fontWeight: "bold" }}>
          <GoMoveToTop />
        </p>
        <p style={{ marginTop: -25 }}>Top</p>
      </a>
    </div>
  </>
);
};

export default KidsAccessorie;
